/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IAny, IGeneric } from '@msdyn365-commerce/core-internal';
import React from 'react';
import { AddModuleControl, IAddModuleProps } from './add-module-control';
import SafeRenderModuleWithContext from './safe-render-module';

export type IAddModuleWrapperProps = {
    id: string;
    safeRenderProps: IGeneric<IAny>;
    addModuleProps: IAddModuleProps;
};
/**
 * Add module wrapper component: Wraps the safe render component and add module control component inside a div tag to properly render modules with its respective add sibling box on site builder.
 */
export class AddModuleWrapper extends React.Component<IAddModuleWrapperProps> {
    public constructor(props: IAddModuleWrapperProps) {
        super(props);
    }
    public render(): JSX.Element {
        const { safeRenderProps, addModuleProps, ...props } = this.props;
        return (
            <div>
                <SafeRenderModuleWithContext {...safeRenderProps} {...props} />
                <AddModuleControl {...addModuleProps} />
            </div>
        );
    }
}
